<!--
 * @Description: 新客评审 - 详情页面
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm ref="detailFormRef" type="view" :isEdit="false" v-model:value="dataForm" :reviewHistory="reviewHistory"/>
    </dc-layout-content>
  </dc-layout-main>
  <cos-footer-button :hideOk="true">
    <SellerButton
      v-permission="'ofbu_new_client_evaluation_submit_review_btn'"
      controlType="none"
      @click="goToEdit()"
      v-if="dataForm.auditStatus === 11"
    >{{ t('btn.review') }}</SellerButton
    >
  </cos-footer-button>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
import { newClientEvaluationDetail, newClientEvaluationReviewHistory } from '@/api/overseasSales/newClientEvaluation'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const queryClueId = computed(() => route.query.newClientId as unknown as number)
const dataForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})
const reviewHistory = ref<any[]>([])
const fetchReviewHistory = async () => {
  const res = await newClientEvaluationReviewHistory({ id: route.query.newClientId as unknown as number })
  reviewHistory.value = res.data
}
const getDetails = () => {
  newClientEvaluationDetail({ id: route.query.newClientId as unknown as number }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => {
  getDetails()
  fetchReviewHistory()
})

const goToEdit = () => {
  router.push({ path: '/ofbu/newClientEvaluation/edit', query: { newClientId: queryClueId.value } })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuNewClientEvaluationView' }
</script>

<style scoped></style>
